import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { EditHubSegmentationItemsDrawerComponent } from '@main-client/src/app/edit-hub-segmentation-items-drawer/edit-hub-segmentation-items-drawer.component';

import { Group } from '@libs/src/models/group.model';

@Injectable()
export class EditHubSegmentationItemsDrawerService {
  constructor(private readonly drawerService: NzDrawerService) {}

  openDrawer(group: Group, segmentationKey: string, segmentationName: string) {
    return this.drawerService.create({
      nzBodyStyle: { padding: 0 },
      nzContent: EditHubSegmentationItemsDrawerComponent,
      nzData: { data: { group, segmentationKey, segmentationName } },
      nzTitle: $localize`:@@editHubSegmentationItemsDrawer.title: Edit ${segmentationName}`,
      nzWidth: '600px',
    }).afterClose;
  }
}
